// extracted by mini-css-extract-plugin
export default {"tab":"MobileDownloadModal_tab__lZ2p6","qrCode":"MobileDownloadModal_qrCode__UR3la"};